export const authActionTypes = {
    // SESSION
    CHECK_USER_SESSION: 'A1',
    UPDATE_SESSION_STATUS: 'A2',

    // SIGN UP: EMAIL
    SIGN_UP_EMAIL_START: 'A3',
    SIGN_UP_SUCCESS: 'A4',
    SIGN_UP_FAILURE: 'A5',

    // SIGN IN: EMAIL / GOOGLE / GITHUB
    SIGN_IN_EMAIL_START: 'A6',
    SIGN_IN_GOOGLE_START: 'A7',
    SIGN_IN_GITHUB_START: 'A8',
    SIGN_IN_SUCCESS: 'A9',
    SIGN_IN_FAILURE: 'A10',

    // SIGN OUT
    SIGN_OUT_START: 'A11',
    SIGN_OUT_SUCCESS: 'A12',
    SIGN_OUT_FAILURE: 'A13',

    // FORGOT PASSWORD
    FORGOT_PASSWORD_START: 'A14',
    FORGOT_PASSWORD_SUCCESS: 'A15',
    FORGOT_PASSWORD_FAILURE: 'A16',

    // RESET PASSWORD
    RESET_PASSWORD_START: 'A17',
    RESET_PASSWORD_SUCCESS: 'A18',
    RESET_PASSWORD_FAILURE: 'A19',

    CLEAR_AUTH_ERRORS: 'A20',

    SIGN_IN_MICROSOFT_START: 'A21',

    // UPDATE USER
    UPDATE_USER_START: 'A22',
    UPDATE_USER_SUCCESS: 'A23',
    UPDATE_USER_FAILURE: 'A24',

    // DELETE USER
    DELETE_USER_START: 'A25',
    DELETE_USER_SUCCESS: 'A26',
    DELETE_USER_FAILURE: 'A27',
};










// export const authActionTypes = {
//     // SESSION
//     CHECK_USER_SESSION: 'CHECK_USER_SESSION',
//     UPDATE_SESSION_STATUS: 'UPDATE_SESSION_STATUS',

//     // SIGN UP: EMAIL
//     SIGN_UP_EMAIL_START: 'SIGN_UP_EMAIL_START',
//     SIGN_UP_SUCCESS: 'SIGN_UP_SUCCESS',
//     SIGN_UP_FAILURE: 'SIGN_UP_FAILURE',

//     // SIGN IN: EMAIL / GOOGLE / GITHUB
//     SIGN_IN_EMAIL_START: 'SIGN_IN_EMAIL_START',
//     SIGN_IN_GOOGLE_START: 'SIGN_IN_GOOGLE_START',
//     SIGN_IN_GITHUB_START: 'SIGN_IN_GITHUB_START',
//     SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
//     SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',

//     // SIGN OUT
//     SIGN_OUT_START: 'SIGN_OUT_START',
//     SIGN_OUT_SUCCESS: 'SIGN_OUT_SUCCESS',
//     SIGN_OUT_FAILURE: 'SIGN_OUT_FAILURE',

//     // FORGOT PASSWORD
//     FORGOT_PASSWORD_START: 'FORGOT_PASSWORD_START',
//     FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
//     FORGOT_PASSWORD_FAILURE: 'FORGOT_PASSWORD_FAILURE',

//     // RESET PASSWORD
//     RESET_PASSWORD_START: 'RESET_PASSWORD_START',
//     RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
//     RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',

//     CLEAR_AUTH_ERRORS: 'CLEAR_AUTH_ERRORS',

//     SIGN_IN_MICROSOFT_START: 'SIGN_IN_MICROSOFT_START',
// };
